import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { FiPlus } from "react-icons/fi";
import { FiMoreVertical } from "react-icons/fi";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { MdDeleteOutline } from "react-icons/md";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../validation/validationConstant";
import {
  updateEducationJobseeker,
  deleteEducationJobseeker,
} from "../service/apis/auth.api";
import { updateExperience } from "../store/auth.store";
import { showError, showSuccess } from "../utils/Common";

const WorkExpDetailsScreen = () => {
  const dispatch = useDispatch();
  const [editingExperienceId, setEditingExperienceId] = useState<string | null>(
    null
  );

  const [showEditExperience, setShowEditExperience] = useState(false);
  const handleCloseEditWK = () => {
    setShowEditExperience(false);
  };

  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => {
    setShowWork(false);
    setEditingExperienceId(null);
  };
  const handleShowWK = () => {
    setShowWork(true);
    setEditingExperienceId(null);
  };

  const { user } = useSelector((state: RootState) => state.authSlice);

  const workProfileik = useFormik({
    initialValues: {
      from: "",
      to: "",
      jobRole: "",
      companyName: "",
      responsibilty: "",
    },
    validationSchema: yup.object({
      from: yup.string().trim().required(ValidationCons.EDU_FROM_REQUIRED),
      to: yup.string().trim().required(ValidationCons.EDU_TO_REQUIRED),
      jobRole: yup.string().trim().required(ValidationCons.JOBROLE_REQUIRED),
      companyName: yup
        .string()
        .trim()
        .required(ValidationCons.COMPANY_REQUIRED),
      responsibilty: yup
        .string()
        .trim()
        .required(ValidationCons.RESPONSIBITY_REQUIRED),
    }),
    onSubmit: async (values: any, { resetForm }) => {
      // setLoading(true);
      // console.log(222);

      try {
        // let bodyData={
        //     'experience[from]':values.from,
        //     'experience[to]': values.to,
        //     'experience[designation]': values.jobRole,
        //     'experience[companyName]': values.companyName,
        //     'experience[responsibility]': values.responsibilty
        // }

        // const response = await updateAccountDetails(bodyData);

        let bodyData = {
          // '_id':editingEducationId,
          from: values.from,
          to: values.to,
          designation: values.jobRole,
          companyName: values.companyName,
          responsibility: values.responsibilty,
        };

        const response = await updateEducationJobseeker(bodyData, "experience");
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseWK();
            // dispatch(setUser(response.user));
            dispatch(updateExperience(response.data));
            showSuccess("Work Experience Updated successfully");
            resetForm();
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error?.message);
      }
    },
  });

  const getYearFromDate = (dateString: string): number => {
    const date = new Date(dateString);
    return date.getUTCFullYear(); // or date.getFullYear() if local timezone is acceptable
  };

  function getOnlyDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const experienceEditProfileik = useFormik({
    initialValues: {
      from: "",
      to: "",
      jobRole: "",
      companyName: "",
      responsibilty: "",
    },
    validationSchema: yup.object({
      from: yup.string().trim().required(ValidationCons.EDU_FROM_REQUIRED),
      to: yup.string().trim().required(ValidationCons.EDU_TO_REQUIRED),
      jobRole: yup.string().trim().required(ValidationCons.JOBROLE_REQUIRED),
      companyName: yup
        .string()
        .trim()
        .required(ValidationCons.COMPANY_REQUIRED),
      responsibilty: yup
        .string()
        .trim()
        .required(ValidationCons.RESPONSIBITY_REQUIRED),
    }),
    onSubmit: async (values: any, { resetForm }) => {
      // setLoading(true);
      // console.log(222);

      try {
        let bodyData = {
          _id: editingExperienceId,
          from: values.from,
          to: values.to,
          designation: values.jobRole,
          companyName: values.companyName,
          responsibility: values.responsibilty,
        };

        const response = await updateEducationJobseeker(bodyData, "experience");
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseEditWK();
            dispatch(updateExperience(response.data));
            showSuccess("Work Experience Updated successfully");
            resetForm();
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error?.message);
      }
    },
  });

  const editingExperience = (expId: string) => {
    setEditingExperienceId(expId);

    const editExperienceData: any = user?.experience.filter(
      (item) => item?._id === expId
    );
    // console.log(editExperienceData,12313);

    experienceEditProfileik.setValues({
      from: getOnlyDate(editExperienceData[0].from),
      to: getOnlyDate(editExperienceData[0].to),
      jobRole: editExperienceData[0].designation,
      companyName: editExperienceData[0].companyName,
      responsibilty: editExperienceData[0].responsibility,
    });
    setShowEditExperience(true);
  };
  const deleteExperience = (expId: string) => {
    const editExperienceData: any = user?.experience.filter(
      (item) => item?._id !== expId
    );
    deleteEducationJobseeker(expId, "experience");
    dispatch(updateExperience(editExperienceData));
    showSuccess("Work Experience Deleted successfully");
  };
  return (
    <>
      <div className="comnbrdrGap profileEdit mb-4">
        <div className="d-flex">
          <h3>Work & Experience</h3>
          <button className="editbtn" onClick={handleShowWK}>
            <FiPlus /> Add
          </button>
        </div>
        {user?.experience &&
          user?.experience?.map((exp: any) => (
            <div className="moreedit-holder" key={exp?._id}>
              <div className="d-flex">
                <h6>
                  {getYearFromDate(exp?.from)}-{getYearFromDate(exp?.to)}
                </h6>
                <Dropdown as={NavItem} className="editnow">
                  <Dropdown.Toggle className="profiledropdown" as={NavLink}>
                    <FiMoreVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      className=""
                      onClick={() => {
                        editingExperience(exp?._id);
                      }}
                    >
                      <LuPencilLine /> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        deleteExperience(exp?._id);
                      }}
                    >
                      <MdDeleteOutline /> Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <h6>
                {exp?.designation} - <span>{exp?.companyName}</span>
              </h6>
              <p>{exp?.responsibility} </p>
            </div>
          ))}
      </div>

      {/* Add Work Experience model*/}
      <Modal
        show={showWork}
        onHide={handleCloseWK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Add Work Experience</h3>
            <Form className="modalSearch" onSubmit={workProfileik.handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Starting date"
                  name="from"
                  onChange={workProfileik.handleChange}
                  onBlur={workProfileik.handleBlur}
                  value={workProfileik.values.from}
                  isInvalid={
                    !!workProfileik.errors.from &&
                    Boolean(workProfileik.touched.from)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof workProfileik.errors.from === "string" &&
                    workProfileik.errors.from}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Ending date"
                  name="to"
                  onChange={workProfileik.handleChange}
                  onBlur={workProfileik.handleBlur}
                  value={workProfileik.values.to}
                  isInvalid={
                    !!workProfileik.errors.to &&
                    Boolean(workProfileik.touched.to)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof workProfileik.errors.to === "string" &&
                    workProfileik.errors.to}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Job Role</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Job Role"
                  name="jobRole"
                  onChange={workProfileik.handleChange}
                  onBlur={workProfileik.handleBlur}
                  value={workProfileik.values.jobRole}
                  isInvalid={
                    !!workProfileik.errors.jobRole &&
                    Boolean(workProfileik.touched.jobRole)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof workProfileik.errors.jobRole === "string" &&
                    workProfileik.errors.jobRole}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Company name"
                  name="companyName"
                  onChange={workProfileik.handleChange}
                  onBlur={workProfileik.handleBlur}
                  value={workProfileik.values.companyName}
                  isInvalid={
                    !!workProfileik.errors.companyName &&
                    Boolean(workProfileik.touched.companyName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof workProfileik.errors.companyName === "string" &&
                    workProfileik.errors.companyName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Responsibility</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
                  name="responsibilty"
                  onChange={workProfileik.handleChange}
                  onBlur={workProfileik.handleBlur}
                  value={workProfileik.values.responsibilty}
                  isInvalid={
                    !!workProfileik.errors.responsibilty &&
                    Boolean(workProfileik.touched.responsibilty)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof workProfileik.errors.responsibilty === "string" &&
                    workProfileik.errors.responsibilty}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-flex gp-10">
                {/* <Button className="btn btn-black w-100" type="button">Add More</Button> */}
                <Button className="btn w-100" type="submit">
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEditExperience}
        onHide={handleCloseEditWK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Edit Work Experience</h3>
            <Form
              className="modalSearch"
              onSubmit={experienceEditProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Starting date"
                  name="from"
                  onChange={experienceEditProfileik.handleChange}
                  onBlur={experienceEditProfileik.handleBlur}
                  value={experienceEditProfileik.values.from}
                  isInvalid={
                    !!experienceEditProfileik.errors.from &&
                    Boolean(experienceEditProfileik.touched.from)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof experienceEditProfileik.errors.from === "string" &&
                    experienceEditProfileik.errors.from}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Ending date"
                  name="to"
                  onChange={experienceEditProfileik.handleChange}
                  onBlur={experienceEditProfileik.handleBlur}
                  value={experienceEditProfileik.values.to}
                  isInvalid={
                    !!experienceEditProfileik.errors.to &&
                    Boolean(experienceEditProfileik.touched.to)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof experienceEditProfileik.errors.to === "string" &&
                    experienceEditProfileik.errors.to}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Job Role</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Job Role"
                  name="jobRole"
                  onChange={experienceEditProfileik.handleChange}
                  onBlur={experienceEditProfileik.handleBlur}
                  value={experienceEditProfileik.values.jobRole}
                  isInvalid={
                    !!experienceEditProfileik.errors.jobRole &&
                    Boolean(experienceEditProfileik.touched.jobRole)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof experienceEditProfileik.errors.jobRole === "string" &&
                    experienceEditProfileik.errors.jobRole}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Company name"
                  name="companyName"
                  onChange={experienceEditProfileik.handleChange}
                  onBlur={experienceEditProfileik.handleBlur}
                  value={experienceEditProfileik.values.companyName}
                  isInvalid={
                    !!experienceEditProfileik.errors.companyName &&
                    Boolean(experienceEditProfileik.touched.companyName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof experienceEditProfileik.errors.companyName ===
                    "string" && experienceEditProfileik.errors.companyName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Responsibility</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
                  name="responsibilty"
                  onChange={experienceEditProfileik.handleChange}
                  onBlur={experienceEditProfileik.handleBlur}
                  value={experienceEditProfileik.values.responsibilty}
                  isInvalid={
                    !!experienceEditProfileik.errors.responsibilty &&
                    Boolean(experienceEditProfileik.touched.responsibilty)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof experienceEditProfileik.errors.responsibilty ===
                    "string" && experienceEditProfileik.errors.responsibilty}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-flex gp-10">
                {/* <Button className="btn btn-black w-100" type="button">Add More</Button> */}
                <Button className="btn w-100" type="submit">
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Add Work Experience model*/}
    </>
  );
};
export default WorkExpDetailsScreen;
